import { useContext, useEffect, useState } from 'react';

import { AuthContext } from '../../contexts/AuthContext';

import Select from 'react-select';
import ButtonLoader from '../ButtonLoader';

import { getSydneyDateObject } from '../../utils/dateUtils';

import { UserIcon } from '@heroicons/react/20/solid';

const days = Array.from({ length: 31 }, (_, i) => {
  return {
    value: i + 1,
    label: i + 1
  }
});

const months = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' }
];

const generateBirthYears = () => {
  const currentYear = new Date().getFullYear();
  const oldestYear = currentYear - 66;
  const youngestYear = currentYear - 18;

  return Array.from({ length: youngestYear - oldestYear + 1 }, (_, i) => {
    const year = oldestYear + i;
    return {
      value: year,
      label: year
    };
  });
};

const birthYears = generateBirthYears();

const GeneralInformation = ({ isLoading, onSubmit }) => {
  const { user } = useContext(AuthContext);

  const [fullName, setFullName] = useState(user?.fullName || '');
  const [preferredName, setPreferredName] = useState(user?.preferredName || '');
  const [profilePicture, setProfilePicture] = useState(null);
  const [profilePicturePreview, setProfilePicturePreview] = useState(null);

  const generateSelectObject = (value) => {
    return {
      value,
      label: value
    };
  }

  const generateSelectMonthObject = (value) => {
    return {
      value,
      label: months[value - 1].label
    };
  }

  const [day, setDay] = useState(user?.dateOfBirth
    ? generateSelectObject(getSydneyDateObject(user?.dateOfBirth).getDate())
    : ''
  );

  const [month, setMonth] = useState(user?.dateOfBirth
    ? generateSelectMonthObject(getSydneyDateObject(user?.dateOfBirth).getMonth() + 1)
    : ''
  );

  const [year, setYear] = useState(user?.dateOfBirth
    ? generateSelectObject(getSydneyDateObject(user?.dateOfBirth).getFullYear())
    : ''
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    const pad = (n) => String(n).padStart(2, '0');

    const dateString = `${year.value}-${pad(month.value)}-${pad(day.value)}`;

    onSubmit({
      fullName,
      preferredName,
      dateOfBirth: dateString,
      profilePicture
    });
  }

  const handleProfilePictureChanged = (e) => {
    const file = e.target.files[0];
    setProfilePicture(file);
  }

  useEffect(() => {
    let objectUrl = null;

    if (profilePicture) {
      objectUrl = URL.createObjectURL(profilePicture)
      setProfilePicturePreview(objectUrl)
    }

    return () => URL.revokeObjectURL(objectUrl)
  }, [profilePicture])

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className='flex flex-col gap-4'
      >
        <div className='flex items-center gap-2'>
          <div>
            {
              profilePicturePreview || user?.profilePicture
                ? <img src={profilePicturePreview || user?.profilePicture} className="h-[50px] w-[50px] rounded-full" alt={user?.fullName} />
                : <div className="h-[50px] w-[50px] bg-gray-300 rounded-full">
                  <UserIcon className="h-full w-full text-gray-500 mx-auto" />
                </div>
            }
          </div>

          <label htmlFor='profile-picture' className='flex items-center gap-4'>
            <span className='py-1 px-2 text-xs font-semibold cursor-pointer rounded-md bg-ase-blue text-white'>Change photo</span>

            <input
              className='hidden'
              onChange={handleProfilePictureChanged}
              type="file"
              id="profile-picture"
              accept="image/*" />
          </label>

        </div>

        <label className='flex flex-col gap-1'>
          <span>Full Name</span>
          <input type="text" value={fullName} onChange={e => setFullName(e.target.value)} required />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Preferred Name</span>
          <input type="text" value={preferredName} onChange={e => setPreferredName(e.target.value)} required />
        </label>

        <div className='flex flex-col gap-1'>
          <label>Date of birth</label>

          <div className='grid md:grid-cols-3 gap-2 items-center'>
            <Select options={days} placeholder="Select day" value={day} onChange={setDay} required />
            <Select options={months} placeholder="Select month" value={month} onChange={setMonth} required />
            <Select options={birthYears} placeholder="Select year" value={year} onChange={setYear} required />
          </div>
        </div>

        <div className='flex'>
          <button
            type="submit"
            className='bg-ase-blue h-[48px] px-4 font-semibold text-white rounded-md flex items-center justify-center'
          >
            {isLoading ? <ButtonLoader /> : 'Update'}
          </button>
        </div>
      </form>
    </>
  )
}

export default GeneralInformation;
